import React from 'react';

export const Comet = () => {
  return (
    <svg viewBox='0 0 736 533' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M184.156 254.001L534.937 53.5784C586.726 23.9878 652.697 41.9836 682.288 93.7729C711.878 145.562 693.883 211.534 642.093 241.124L291.313 441.547L184.156 254.001Z'
        fill='#3C908D'
      />
      <path
        d='M228.932 269.88C225.644 264.125 218.314 262.126 212.56 265.414L0.70253 386.461L12.6088 407.299L224.466 286.252C230.221 282.964 232.22 275.634 228.932 269.88Z'
        fill='#FAFAFF'
      />
      <path
        d='M290.949 289.728C287.661 283.974 280.331 281.974 274.576 285.262L62.7189 406.31L74.6252 427.148L286.483 306.101C292.237 302.813 294.236 295.483 290.949 289.728Z'
        fill='#FAFAFF'
      />
      <path
        d='M296.528 341.823C293.24 336.069 285.91 334.069 280.155 337.357L68.2979 458.405L80.2042 479.243L292.061 358.196C297.816 354.908 299.815 347.578 296.528 341.823Z'
        fill='#FAFAFF'
      />
      <path
        d='M300.37 394.91C297.082 389.156 289.752 387.156 283.998 390.444L72.1403 511.492L84.0466 532.33L295.904 411.283C301.658 407.995 303.658 400.665 300.37 394.91Z'
        fill='#FAFAFF'
      />
      <ellipse
        cx='557.257'
        cy='165.211'
        rx='85'
        ry='84'
        transform='rotate(-29.742 557.257 165.211)'
        fill='#ADE1E5'
      />
      <rect
        x='299.756'
        y='270.876'
        width='44'
        height='24'
        rx='12'
        transform='rotate(-29.742 299.756 270.876)'
        fill='#ADE1E5'
      />
      <rect
        x='351.852'
        y='241.11'
        width='46'
        height='24'
        rx='12'
        transform='rotate(-29.742 351.852 241.11)'
        fill='#ADE1E5'
      />
      <rect
        x='370.824'
        y='340.835'
        width='46'
        height='24'
        rx='12'
        transform='rotate(-29.742 370.824 340.835)'
        fill='#ADE1E5'
      />
      <rect
        x='442.022'
        y='300.155'
        width='46'
        height='24'
        rx='12'
        transform='rotate(-29.742 442.022 300.155)'
        fill='#ADE1E5'
      />
      <rect
        x='488.041'
        y='273.862'
        width='127'
        height='24'
        rx='12'
        transform='rotate(-29.742 488.041 273.862)'
        fill='#ADE1E5'
      />
      <rect
        x='415.605'
        y='259.966'
        width='173'
        height='24'
        rx='12'
        transform='rotate(-29.742 415.605 259.966)'
        fill='#ADE1E5'
      />
      <rect
        x='405.685'
        y='210.352'
        width='128'
        height='24'
        rx='12'
        transform='rotate(-29.742 405.685 210.352)'
        fill='#ADE1E5'
      />
      <rect
        x='299.387'
        y='215.804'
        width='264'
        height='24'
        rx='12'
        transform='rotate(-29.742 299.387 215.804)'
        fill='#ADE1E5'
      />
      <path
        d='M162.325 280.295C159.037 274.541 161.037 267.211 166.791 263.923L378.648 142.876L390.555 163.714L178.697 284.761C172.943 288.049 165.613 286.05 162.325 280.295Z'
        fill='#3C908D'
      />
      <path
        d='M186.138 321.972C182.85 316.218 184.849 308.888 190.604 305.6L402.461 184.552L414.367 205.391L202.51 326.438C196.756 329.726 189.425 327.727 186.138 321.972Z'
        fill='#3C908D'
      />
      <path
        d='M209.95 363.649C206.662 357.895 208.662 350.565 214.416 347.277L426.274 226.229L438.18 247.068L226.323 368.115C220.568 371.403 213.238 369.403 209.95 363.649Z'
        fill='#3C908D'
      />
      <path
        d='M233.763 405.326C230.475 399.572 232.475 392.241 238.229 388.954L450.086 267.906L461.993 288.745L250.135 409.792C244.381 413.08 237.051 411.08 233.763 405.326Z'
        fill='#3C908D'
      />
      <path
        d='M257.575 447.003C254.288 441.248 256.287 433.918 262.042 430.63L473.899 309.583L485.805 330.421L273.948 451.469C268.193 454.757 260.863 452.757 257.575 447.003Z'
        fill='#3C908D'
      />
      <rect
        x='190.604'
        y='305.6'
        width='362'
        height='24'
        rx='12'
        transform='rotate(-29.742 190.604 305.6)'
        fill='#3C908D'
      />
      <rect
        x='154.506'
        y='381.507'
        width='412'
        height='24'
        rx='12'
        transform='rotate(-29.742 154.506 381.507)'
        fill='#3C908D'
      />
      <rect
        x='273.828'
        y='368.614'
        width='325'
        height='24'
        rx='12'
        transform='rotate(-29.742 273.828 368.614)'
        fill='#3C908D'
      />
      <rect
        className='particle-1'
        x='172.241'
        y='426.657'
        width='44'
        height='24'
        rx='12'
        transform='rotate(-29.742 172.241 426.657)'
        fill='#3C908D'
      />
      <rect
        className='particle-2'
        x='112.33'
        y='460.887'
        width='44'
        height='24'
        rx='12'
        transform='rotate(-29.742 112.33 460.887)'
        fill='#3C908D'
      />
      <rect
        className='particle-3'
        x='27'
        y='343.794'
        width='107'
        height='24'
        rx='12'
        transform='rotate(-29.742 27 343.794)'
        fill='#3C908D'
      />
    </svg>
  );
};
